import React from 'react';
import PropTypes from 'prop-types';
import UploadButton from './UploadButton';
import FileList from './FileList';

export default function FilePicker({
  handleFileSelect,
  isEditable,
  files,
  handleRemoveFile,
  httpParams,
  error,
  errorClassName,
  mainWrapperClassName,
  editableStateSectionHeader,
  notEditableStateSectionHeader,
  sectionHeaderClassName,
  uploadButtonText,
  doNotRemoveFiles,
  infoMessage,
  listSectionId,
}) {
  if (!isEditable && !files.length) return null;

  return (
    <section className={`ect-file-picker _width_pc_100 ${mainWrapperClassName}`}>
      <div
        className={`${sectionHeaderClassName ? '' : 'ect-file-picker__header _color_gray'} ${sectionHeaderClassName}`}
      >
        {isEditable ? editableStateSectionHeader : notEditableStateSectionHeader}
      </div>
      {infoMessage && <div className='__main-alert-label _margin_top_0'>{infoMessage}</div>}
      {isEditable && (
        <UploadButton
          files={files}
          handleFileSelect={handleFileSelect}
          errorClassName={errorClassName}
          error={error}
          uploadButtonText={uploadButtonText}
        />
      )}
      <FileList
        files={files}
        isEditable={isEditable}
        httpParams={httpParams}
        handleRemoveFile={handleRemoveFile}
        doNotRemoveFiles={doNotRemoveFiles}
        listSectionId={listSectionId}
      />
    </section>
  );
}

FilePicker.propTypes = {
  handleFileSelect: PropTypes.func,
  handleRemoveFile: PropTypes.func,
  handleDownloadFile: PropTypes.func,
  isEditable: PropTypes.bool,
  files: PropTypes.array,
  error: PropTypes.string,
  mainWrapperClassName: PropTypes.string,
  errorClassName: PropTypes.string,
  httpParams: PropTypes.shape({
    currentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    currentAPI: PropTypes.string,
  }),
  editableStateSectionHeader: PropTypes.string,
  notEditableStateSectionHeader: PropTypes.string,
  sectionHeaderClassName: PropTypes.string,
  uploadButtonText: PropTypes.string,
  doNotRemoveFiles: PropTypes.bool,
  infoMessage: PropTypes.string,
};

FilePicker.defaultProps = {
  handleFileSelect: () => {},
  isEditable: true,
  files: [],
  error: '',
  mainWrapperClassName: '',
  errorClassName: '',
  httpParams: {
    currentId: 0,
    currentMethod: '',
  },
  editableStateSectionHeader: 'Upload Test Report *',
  uploadButtonText: 'Upload Test Report',
  notEditableStateSectionHeader: 'Uploaded documents',
  sectionHeaderClassName: '',
  doNotRemoveFiles: false,
  infoMessage: '',
};



// WEBPACK FOOTER //
// ./src/app/Components/FilePicker/index.jsx